import { ExamplePage, PageContentLoader } from '@components';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

export const Routes = () => {
  const router = createBrowserRouter([
    // Example page created in React
    {
      path: 'example',
      element: <ExamplePage />,
    },
    // This is catch-all component for EPI Content Pages
    // It will catch all other URLs and try to map it to the EPI components
    {
      path: '/*',
      element: <PageContentLoader />,
    },
  ]);
  return <RouterProvider router={router} />;
};
